import { render } from "./CopyrightLogin.vue?vue&type=template&id=6f9598ba"
import script from "./CopyrightLogin.vue?vue&type=script&lang=js"
export * from "./CopyrightLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__